import React from 'react';
import { cn } from '../../../../../../utils/styles';
import AccountFeature from '../Feature';
import { IAccountInfo } from '../Delivery';

const noStyles =
  'border-addition10 text-addition10 ' +
  'hover:bg-addition10 hover:text-white data-[active=true]:bg-addition10 data-[active=true]:text-white';
const yesStyles =
  'border-[#54C1FB] text-[#54C1FB] ' +
  'hover:bg-[#54C1FB] hover:text-white data-[active=true]:bg-[#54C1FB] data-[active=true]:text-white';

function AccountAttachment({ label, isEdit, account, handleUpdate }: IAccountInfo) {
  return (
    <div className="flex gap-[10px]">
      <div className="xl:min-w-[120px] min-w-[100px] text-[12px] uppercase font-medium opacity-60 text-addition1">
        {label}
      </div>
      {!isEdit ? (
        <AccountFeature
          active
          accountKey="attachment"
          value={account.attachment ? 'yes' : 'no'}
          className={cn('cursor-auto', account.attachment ? yesStyles : noStyles)}
        />
      ) : (
        <div>
          <div className="flex flex-wrap gap-[5px] mb-[5px]">
            <AccountFeature
              active={account.attachment === true}
              accountKey="attachment"
              value="yes"
              className={yesStyles}
              handleUpdate={handleUpdate}
            />
            <AccountFeature
              active={account.attachment === false}
              accountKey="attachment"
              value="no"
              className={noStyles}
              handleUpdate={handleUpdate}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default AccountAttachment;
